module.exports = __webpack_public_path__ + "static/media/rest_api_intermidiate.e929324a.e929324a.png";